import { render } from "./BovineByFarmChart.vue?vue&type=template&id=f81db13a&scoped=true"
import script from "./BovineByFarmChart.vue?vue&type=script&lang=js"
export * from "./BovineByFarmChart.vue?vue&type=script&lang=js"

import "./BovineByFarmChart.vue?vue&type=style&index=0&id=f81db13a&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81db13a"]])

export default __exports__